// extracted by mini-css-extract-plugin
export default {"container":"EmailSendAndCreateActivitiesButton_container__0T06g"};